import { render, staticRenderFns } from "./CourseListDialog.vue?vue&type=template&id=6872522e&scoped=true&"
import script from "./CourseListDialog.vue?vue&type=script&lang=js&"
export * from "./CourseListDialog.vue?vue&type=script&lang=js&"
import style0 from "./CourseListDialog.vue?vue&type=style&index=0&id=6872522e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872522e",
  null
  
)

export default component.exports